import { render, staticRenderFns } from "./CreateaccountNew2.vue?vue&type=template&id=8f91eae8&scoped=true&"
import script from "./CreateaccountNew2.vue?vue&type=script&lang=js&"
export * from "./CreateaccountNew2.vue?vue&type=script&lang=js&"
import style0 from "./CreateaccountNew2.vue?vue&type=style&index=0&id=8f91eae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f91eae8",
  null
  
)

export default component.exports